import styled from 'styled-components';
import EmployeeSummary from './components/EmployeeSummary';
import EmployeesTableAndFilter from './components/EmployeesTableAndFilter';

const SalonEmployeeListPage = () => {
  return (
    <ContainerStyled>
      <EmployeeSummary />
      <EmployeesTableAndFilter />
    </ContainerStyled>
  );
};

export default SalonEmployeeListPage;

const ContainerStyled = styled.div`
  height: calc(100vh - 129px);
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
